export default {
  DIFF_EQUAL: 0,
  DIFF_DELETE: -1,
  DIFF_INSERT: 1,
  EDITOR_RIGHT: 'right',
  EDITOR_LEFT: 'left',
  RTL: 'rtl',
  LTR: 'ltr',
  SVG_NS: 'http://www.w3.org/2000/svg',
  DIFF_GRANULARITY_SPECIFIC: 'specific',
  DIFF_GRANULARITY_BROAD: 'broad',
}
